<template>
    <NavBar />
    <div class="metrics-configuration">
        <router-view />
    </div>
</template>
<script lang="ts">
import { defineComponent, inject } from 'vue';

export default defineComponent({
    setup: () => {
        const user = inject('loggedInUser');
        return { user };
    }
});
</script>
<style lang="scss">
@import "./styles.scss";
.in-beta{
    .navbar {
        background: rgb(159, 22, 45);
    }
}
</style>
